import React from "react";
import cx from "classnames";
import classes from "./FormStyleOfPlanBox.module.scss";
import perksIcon from "../../../assets/images/perksIcon.png";
import { NavLink } from "react-router-dom";
import * as ROUTES from "../../../constants/routes";

const formStyleOfPlanBox = (props) => {
  let perks = [];
  let navlink = "";
  if (props.perksLevel === "1") {
    navlink = ROUTES.PAGE_5_LINK;
  } else {
    navlink = props.buttonLink;
  }
  for (let j = 0; j < props.perksLevel; j++) {
    perks.push(<img src={perksIcon} alt="Perks Level Icon" key={j} />);
  }
  const activeLink = props.buttonName === "Select";
  return (
    <>
      {props.soldOut ? (
        <div className={classes.FormStyleOfPlanBoxWrapper}>
          <div className={cx(classes.FormStyleOfPlanBox, classes.planSoldOut)}>
            <div className={classes._FormStyleOfPlanBox}>
              <div className={classes.FormStyleOfPlanBoxHeader}>
                <img
                  src={props.icon}
                  alt={props.title + " Icon"}
                  style={props.iconStyle}
                />
                <div className={classes.title}>{props.title}</div>
                <div className={classes.startingPrice}>
                  {props.startingPrice}
                </div>
              </div>
              <div className={classes.description}>{props.description}</div>
              <div className={classes.button}>Sold Out</div>
            </div>
          </div>
        </div>
      ) : (
        activeLink ? (
          <NavLink
            to={{ pathname: navlink, from: props.planType }}
            className={classes.FormStyleOfPlanBoxWrapper}
            onClick={props.updateSelectedChoices}
          >
            <div className={classes.FormStyleOfPlanBox}>
              <div className={classes._FormStyleOfPlanBox}>
                <div className={classes.FormStyleOfPlanBoxHeader}>
                  <img
                    src={props.icon}
                    alt={props.title + " Icon"}
                    // style={props.iconStyle}
                  />
                  <div>
                    <div className={classes.title}>{props.title}</div>
                    <div className={classes.startingPrice}>
                      {props.startingPrice}
                    </div>
                  </div>
                </div>
                <div className={classes.description}>{props.description}</div>
                <div
                  className={cx(
                    classes.button,
                    !activeLink ? classes.disable_btn : null
                  )}
                >
                  {props.buttonName}
                </div>
              </div>
            </div>
            {/* <div className={classes.FormStyleOfPlanBoxPerks}>
              <div className={classes.title}>Benefits & Seating Location</div>
              <div className={classes.perksWrapper}>{perks}</div>
            </div> */}
          </NavLink>
        ) : (
          <div className={classes.FormStyleOfPlanBoxWrapper}>
            <div className={classes.FormStyleOfPlanBox}>
              <div className={classes._FormStyleOfPlanBox}>
                <div className={classes.FormStyleOfPlanBoxHeader}>
                  <img
                    src={props.icon}
                    alt={props.title + " Icon"}
                    // style={props.iconStyle}
                  />
                  <div>
                    <div className={classes.title}>{props.title}</div>
                    <div className={classes.startingPrice}>
                      {props.startingPrice}
                    </div>
                  </div>
                </div>
                <div className={classes.description}>{props.description}</div>
                <div className={cx(classes.button, classes.disable_btn)}>
                  {props.buttonName}
                </div>
              </div>
            </div>
            {/* <div className={classes.FormStyleOfPlanBoxPerks}>
              <div className={classes.title}>Benefits & Seating Location</div>
              <div className={classes.perksWrapper}>{perks}</div>
            </div> */}
          </div>
        )
      )}
    </>
  );
};

export default formStyleOfPlanBox;
